import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { NewAccountMain } from './NewAccountMain';
import { NewAccountConfirm } from './NewAccountConfirm';
import { NewAccountPlaced } from './NewAccountPlaced';

import { NewAccountStackParamList, NewAccountStackRoutes } from './type';

const NewAccountStack = createNativeStackNavigator<NewAccountStackParamList>();

export const NewAccountNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.NewAccount>> = ({ route }) => {
  const { func, refresh, onChangeView } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <NewAccountStack.Navigator
          initialRouteName={NewAccountStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <NewAccountStack.Screen
            name={NewAccountStackRoutes.Main}
            component={NewAccountMain}
            initialParams={{ onLayout, onData, onReturnData, func, refresh }}
            options={{ headerShown: false }}
          />
          <NewAccountStack.Screen
            name={NewAccountStackRoutes.Confirm}
            component={NewAccountConfirm}
            initialParams={{ onLayout, data, onReturnData, func, refresh, onChangeView }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <NewAccountStack.Screen
            name={NewAccountStackRoutes.Placed}
            component={NewAccountPlaced}
            initialParams={{ onLayout, data, returnData }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </NewAccountStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
